<template>
  <div class="builder-dimension">
    <div
      v-if="dimensionsId"
      :key="`dim${propertiesUid}`"
      style="display: flex; align-items: baseline"
    >
      <div class="help is-size-7 mr-2" style="min-width: 80px">
        <span>{{ $filters.capitalize(dimensionsId) }}</span>
      </div>
      <div
        v-if="datasetsProperties.length"
        class="select is-small"
        style="width: 100%"
      >
        <select
          :key="`selectprop-${dimensionValue}`"
          v-tooltip="{
            content: !canChangeDimensions
              ? `You can't change this after staging datasets in this collection`
              : undefined,
          }"
          style="width: 100%"
          :disabled="!canChangeDimensions"
          @change="(e) => $emit('select-dimension', e.target.value)"
        >
          <option
            v-for="(p, pIndex) in datasetsProperties"
            :key="`${p.prop_value}${pIndex}`"
            :value="p.prop_value"
            :selected="dimensionValue === p.prop_value"
          >
            {{ p.label }}
          </option>
        </select>
      </div>
      <div v-else class="help is-size-7">
        <div v-if="dimensionValue">
          {{ $filters.capitalize(selectedPropertyLabel) }}
        </div>
        <div v-else>Not Applicable or Derived data</div>
      </div>
    </div>
    <div>
      <div
        v-if="constraints.length"
        style="display: flex; align-items: baseline"
      >
        <div class="help is-size-7 mr-2" style="min-width: 80px">
          Filter Preset
        </div>
        <div class="select is-small" style="width: 100%">
          <select
            id="selectConstraintId"
            :key="`select-${dimensionValue}`"
            name="selectConstraintId"
            style="width: 100%"
            @change="(e) => (selectedConstraintId = e.target.value)"
          >
            <option></option>
            <option
              v-for="c in constraints"
              :key="`opt-${c.value}${c.id}`"
              :value="c.id"
              :selected="selectedConstraintId === c.id"
            >
              {{ c.name }}
            </option>
          </select>
        </div>
      </div>
      <div style="display: flex; align-items: baseline; width: 100%">
        <!-- <div class="help is-size-7 mr-2" style="min-width: 80px">Filter</div> -->
        <InputTextFilter
          :key="`inputtextfilt${dimensionValue}${selectedConstraintUid}`"
          :name="`dim${dimensionValue}`"
          :init-input="selectedConstraintValue"
          :list-of-values="files"
          placeholder="e.g. _1.fastq.gz"
          @input="(i) => (columnFilt.input = i)"
          @change-is-regex="(b) => (columnFilt.isRegex = b)"
          @filter-list="(f) => $emit('filter-files', f)"
          @filter-matches="(rem) => $emit('filter-matches', rem)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import InputTextFilter from '@/components/InputTextFilter.vue'

export default {
  name: 'DatasetBuilderDimension',
  emits: [
    'select-dimension',
    'change-filter',
    'filter-files',
    'filter-matches',
  ],
  components: {
    InputTextFilter,
  },
  props: {
    files: {
      type: Array,
      default: () => [],
    },
    dimensionsId: {
      type: String,
      default: null,
    },
    dimensionValue: {
      type: String,
      default: '',
    },
    datasetsProperties: {
      type: Array,
      default: () => [],
    },
    canChangeDimensions: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      selectedConstraintId: '',
      columnFilt: {
        input: '',
        isRegex: false,
      },
    }
  },
  computed: {
    datasetsPropertiesByValue() {
      return this.datasetsProperties.reduce((prop, p) => {
        prop[p.prop_value] = p
        return prop
      }, {})
    },
    selectedProperty() {
      return this.datasetsPropertiesByValue[this.dimensionValue]
    },
    selectedPropertyLabel() {
      return this.datasetsPropertiesByValue[this.dimensionValue]
    },
    constraints() {
      return this.selectedProperty?.constraints || []
    },
    selectedConstraint() {
      return this.constraints?.find((c) => c.id === this.selectedConstraintId)
    },
    selectedConstraintUid() {
      return `${this.selectedConstraint?.id || 'none'}${
        this.selectedConstraint?.value || 'none'
      }`
    },
    selectedConstraintValue() {
      return this.selectedConstraint?.value
    },
    propertiesUid() {
      return (
        this.datasetsProperties
          ?.map((p, index) => `${p.id}${index}${p.prop}${p.prop_value}`)
          ?.join('-') || 'none'
      )
    },
  },
  watch: {
    columnFilt: function (newFilt) {
      this.$emit('change-filter', newFilt)
    },
  },
}
</script>

<style scoped>
.builder-dimension div {
  margin-bottom: 0.2rem;
}
</style>
